const url = process.env.REACT_APP_BACKEND_API_BASE;

const Endpoint = {
  HELIANT_LOCATION: "https://www.google.com/maps?ll=44.801648,20.468606&z=18&t=m&hl=sr&gl=RS&mapclient=embed&cid=2738058163620265291",
  SCHEDULE_PRESENTATION: url + "/public/schedule-presentation",
};

export default Endpoint;
